import { Directive, HostBinding, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
    selector: '[appLoadingIcon]'
})

export class LoadingDirective implements OnChanges {

    @Input('appLoadingIcon') showLoadingIcon!: boolean;
    protected _resetToDefault: Array<string> = [];
    protected _elementClass: Array<string> = [];
    protected _loadingClass: Array<string> = ['fa', 'fa-circle-o-notch', 'fa-spin'];

    constructor(private el: ElementRef) {
        console.log('Loaded LoadingDirective');
        this._elementClass = this.el.nativeElement.className.split(' ');
        this._resetToDefault = this._elementClass;
    }

    @HostBinding('class') get elementClass(): string {
		return this._elementClass.join(' ');
	}

    ngOnChanges(change: SimpleChanges) {
    	if (!change.showLoadingIcon.firstChange) {
	    	if (this.showLoadingIcon) {
	    		this._elementClass = [];
	    		this._elementClass = this._loadingClass;
	    	} else {
	    		this._elementClass = [];
	    		this._elementClass = this._resetToDefault;
	    	}
    	}
    }
}
